module.exports = __webpack_public_path__ + "static/media/light-b-4.0223119e.png";